import { ExportOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import { createStyles } from 'antd-style'

import { NavigateButton } from '@eastcoal/common/components/Button/NavigateButton'
import { stringifyUrl } from '@eastcoal/common/utils/querystring'

import { AuctionListTitleRenderProps } from './interface'

const useStyles = createStyles(({ token }) => ({
  icon: {
    color: token.colorTextTertiary
  }
}))

export const AuctionListTitleRender = ({
  createPath,
  record
}: AuctionListTitleRenderProps) => {
  const { styles } = useStyles()

  return (
    <div>
      <span>{record.title}</span>
      {createPath && (
        <Tooltip title='复制场次'>
          <NavigateButton
            newtab
            icon={<ExportOutlined className={styles.icon} />}
            size='small'
            type='text'
            to={stringifyUrl({
              url: createPath,
              query: {
                id: record.id
              }
            })}
          />
        </Tooltip>
      )}
    </div>
  )
}
